import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PublishKnowledgeAssetMutationVariables = Types.Exact<{
  data: Types.PublishContentInput;
}>;


export type PublishKnowledgeAssetMutation = { publishContent: { success?: boolean | null } };


export const PublishKnowledgeAssetDocument = /*#__PURE__*/ gql`
    mutation PublishKnowledgeAsset($data: PublishContentInput!) {
  publishContent(data: $data) {
    success
  }
}
    `;

export function usePublishKnowledgeAssetMutation() {
  return Urql.useMutation<PublishKnowledgeAssetMutation, PublishKnowledgeAssetMutationVariables>(PublishKnowledgeAssetDocument);
};